import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var GoogleDriveIcon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var iconFill = _ref.iconFill,
      props = _objectWithoutProperties(_ref, ["iconFill"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), iconFill && iconFill === 'brand' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SVGFill, {
    d: "M8.81982 36L10.3999 38.72C10.719 39.2842 11.1858 39.7508 11.75 40.0699L17.3799 30.3199H6.10986C6.1121 30.9697 6.28449 31.6076 6.60986 32.17L8.81982 36Z",
    svgColor: "#0066DA"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M24 18.87L18.3699 9.10999C17.8046 9.43551 17.3355 9.90468 17.01 10.47L6.60987 28.47C6.28131 29.0274 6.10862 29.663 6.10987 30.3101H17.3799L24 18.87Z",
    svgColor: "#00AC47"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M36.25 40.09C36.817 39.7711 37.2868 39.3046 37.6099 38.74L38.26 37.61L41.3999 32.1899C41.7176 31.6248 41.8862 30.9882 41.8899 30.34H30.6499L33.0498 35.05L36.25 40.09Z",
    svgColor: "#EA4335"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M24 18.87L29.6399 9.10999C29.0767 8.78768 28.4387 8.61873 27.7898 8.62H20.21C19.5655 8.62838 18.9331 8.79675 18.3699 9.10999L24 18.87Z",
    svgColor: "#00832D"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M30.6499 30.34H17.4099L11.7798 40.09C12.3366 40.4199 12.9726 40.5927 13.6199 40.59H34.4399C35.086 40.5842 35.7196 40.412 36.2798 40.09L30.6499 30.34Z",
    svgColor: "#2684FC"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M36.1899 19.48L30.99 10.48C30.6654 9.91738 30.2001 9.44876 29.6399 9.12L24 18.88L30.6199 30.35H41.8699C41.8662 29.7049 41.6975 29.0715 41.3799 28.51L36.1899 19.48Z",
    svgColor: "#FFBA00"
  })) : /*#__PURE__*/React.createElement(SVGFill, {
    d: "M29.4199 8.82996L17.0299 29.9399H17V29.99L11.1 40.0601L5.30994 30.77L18.12 8.82996H29.4199ZM42.6899 29.9399L30.5199 8.82996L24.74 18.4399L31.1499 29.9399H42.6899ZM17.5 30.77H42.6899L37.5499 40.38H11.85L17.5 30.77Z"
  }));
});
GoogleDriveIcon.displayName = 'GoogleDriveIcon';
GoogleDriveIcon.defaultProps = {
  'aria-label': 'Google Drive'
};
export default GoogleDriveIcon;